export default {"src":"/_next/static/media/UTI.7f383b11.svg","height":18,"width":18};